@include component-spacing-and-grid;

:host {
    display: block;
}

.main-content-container {
    grid-row: 1;
}

.underlay {
    display: none;
}

:host([underlay]) {
    .underlay {
        display: block;
        background-color: $color-grey-06-bright;
        grid-column: 1 / -1;
        grid-row: 1;
    }

    .main-content-container {
        padding: 80px 0;
        align-items: center;
    }
}

@include mq-3-min {
    :host([limit-content-width]) {
        .main-content-container {
            grid-column: 2 / span 8;
        }
    }
}
